import { SvgIconProps } from '@mui/material';

const ProgressionTick = ({ height = '24', width = '24', className }: SvgIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-label="Progression Tick"
  >
    <rect width="24" height="24" rx="12" fill="#D77348" />
    <path
      d="M8.25523 13.2855C8.19834 14.4036 8.45433 15.4644 8.71032 16.5538C9.42141 15.493 10.1041 14.4323 10.7867 13.3715C11.5831 12.1387 12.408 10.9346 13.2044 9.7018C13.7448 8.87038 14.2852 8.03897 14.8257 7.20755C15.0816 6.80618 15.3376 6.40481 15.5936 6.00343C15.7927 5.71674 15.9918 5.43004 16.3047 5.20069C16.4185 5.11468 16.5323 5.05734 16.6176 5C16.902 5.08601 16.9589 5.31536 16.9874 5.51605C17.0158 5.68807 16.9874 5.86009 16.9874 6.06077C16.8451 6.43348 16.6745 6.77751 16.4754 7.15021C16.1056 7.86695 15.7074 8.61236 15.3376 9.3291C15.1101 9.75914 14.8825 10.1605 14.6266 10.5906C14.3706 11.0493 14.0861 11.508 13.8301 11.9954C13.4319 12.6834 13.0337 13.3715 12.6071 14.0596C12.2373 14.6616 11.8675 15.235 11.4693 15.8371C11.1849 16.2671 10.9005 16.6685 10.5876 17.0699C10.3032 17.4426 9.99028 17.8153 9.62051 18.1593C9.44985 18.3313 9.25075 18.4747 8.99476 18.5607C8.73877 18.5893 8.51122 18.5607 8.25523 18.4747C7.77169 18.3027 7.48726 17.9586 7.37348 17.4426C7.3166 17.2132 7.3166 16.9839 7.28815 16.7545C7.25971 16.4391 7.20282 16.1524 7.17438 15.8371C7.11749 15.3784 6.97528 14.9197 7.00372 14.4323C7.03216 14.1456 7.08905 13.8589 7.23127 13.6009C7.37348 13.3142 7.62947 13.1995 7.94235 13.1708C8.05613 13.1421 8.1699 13.1708 8.25523 13.2855Z"
      fill="white"
    />
  </svg>
);

export default ProgressionTick;
